var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg18Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_21_622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.4106 71.6596H23.141V40.4941C20.1193 43.3192 16.559 45.409 12.4585 46.7628V39.2586C14.6161 38.552 16.9613 37.2133 19.4918 35.2418C22.0223 33.2702 23.7588 30.9703 24.7005 28.3411H31.4106V71.6596Z",
    fill: "url(#paint0_linear_21_622)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M44.1342 47.9983C41.9954 47.0958 40.4412 45.8551 39.4694 44.2753C38.4983 42.6963 38.0124 40.9643 38.0124 39.0809C38.0124 35.8633 39.1357 33.2055 41.3822 31.1059C43.6287 29.0071 46.8214 27.9569 50.961 27.9569C55.0615 27.9569 58.2445 29.0063 60.5105 31.1059C62.7766 33.2055 63.9097 35.8633 63.9097 39.0809C63.9097 41.0818 63.3899 42.8627 62.3502 44.4222C61.3098 45.9816 59.8491 47.1734 57.965 47.9976C60.3584 48.9589 62.1777 50.3624 63.4238 52.2058C64.6698 54.05 65.2928 56.179 65.2928 58.592C65.2928 62.575 64.0227 65.8121 61.4816 68.3034C58.9406 70.7955 55.5618 72.0408 51.3437 72.0408C47.4195 72.0408 44.153 71.011 41.5441 68.9506C38.4637 66.518 36.9238 63.1829 36.9238 58.9446C36.9238 56.6099 37.5024 54.4666 38.6603 52.5147C39.8175 50.5643 41.6421 49.0583 44.1342 47.9983ZM45.0759 58.1513C45.0759 60.4272 45.6597 62.2028 46.8266 63.4775C47.9936 64.7529 49.4506 65.3902 51.1968 65.3902C52.9039 65.3902 54.3165 64.777 55.4345 63.5513C56.5524 62.3256 57.1122 60.5545 57.1122 58.2394C57.1122 56.2189 56.5426 54.5954 55.4051 53.369C54.2668 52.1433 52.8248 51.5301 51.0793 51.5301C49.0581 51.5301 47.5521 52.2269 46.5622 53.6199C45.5708 55.0128 45.0759 56.5233 45.0759 58.1513ZM45.8405 39.67C45.8405 41.3184 46.3061 42.6036 47.238 43.5249C48.1699 44.447 49.4106 44.9081 50.961 44.9081C52.5303 44.9081 53.7861 44.4425 54.7278 43.5099C55.6695 42.578 56.1403 41.2882 56.1403 39.6399C56.1403 38.0903 55.674 36.8495 54.7429 35.9168C53.811 34.9849 52.58 34.5186 51.0499 34.5186C49.4611 34.5186 48.1955 34.9895 47.2538 35.9311C46.3114 36.8743 45.8405 38.1204 45.8405 39.67Z",
    fill: "url(#paint1_linear_21_622)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M76.6846 59.4786V52.4318H69.582V47.5674H76.6846V40.5205H81.4195V47.5674H88.5401V52.4318H81.4195V59.4786H76.6846Z",
    fill: "url(#paint2_linear_21_622)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M50.5 100C43.7515 100 37.2026 98.6779 31.0371 96.0698C25.0826 93.5513 19.7361 89.9465 15.1452 85.3556C10.5542 80.7647 6.94945 75.4174 4.43099 69.4636C1.82213 63.2967 0.5 56.7485 0.5 50C0.5 43.2515 1.82213 36.7026 4.43024 30.5371C6.9487 24.5826 10.5535 19.2361 15.1444 14.6452C19.7353 10.0535 25.0826 6.4487 31.0371 3.93024C37.2026 1.32213 43.7507 0 50.5 0C57.2493 0 63.7967 1.32213 69.9629 3.93024C75.9174 6.4487 81.2639 10.0535 85.8548 14.6444C90.4458 19.2353 94.0505 24.5826 96.569 30.5364C99.1771 36.7026 100.499 43.2507 100.499 49.9992C100.499 56.7478 99.1771 63.2967 96.569 69.4621C94.0505 75.4166 90.4458 80.7631 85.8548 85.3541C81.2639 89.945 75.9166 93.5498 69.9629 96.0683C63.7967 98.6771 57.2485 100 50.5 100ZM50.5 5.1115C25.7486 5.1115 5.6115 25.2486 5.6115 50C5.6115 74.7514 25.7486 94.8885 50.5 94.8885C75.2514 94.8885 95.3885 74.7514 95.3885 50C95.3885 25.2486 75.2514 5.1115 50.5 5.1115Z",
    fill: "url(#paint3_linear_21_622)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M86.9847 35.8656C86.4867 35.8656 86.0136 35.5726 85.8072 35.0851C79.7939 20.8679 65.9345 11.6815 50.4998 11.6815C40.0117 11.6815 30.2226 15.837 22.9347 23.3826C22.4442 23.8903 21.6351 23.9046 21.1281 23.4142C20.6204 22.9238 20.6061 22.1147 21.0965 21.6069C24.8685 17.7015 29.296 14.6309 34.2561 12.4808C39.3917 10.2539 44.8572 9.12537 50.4998 9.12537C58.6903 9.12537 66.593 11.5399 73.3535 16.1067C79.9499 20.5628 85.0697 26.7809 88.1607 34.0892C88.4357 34.7393 88.1313 35.4889 87.4819 35.7639C87.3192 35.8332 87.1504 35.8656 86.9847 35.8656Z",
    fill: "url(#paint4_linear_21_622)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M50.5002 90.8739C40.0361 90.8739 30.0813 86.9233 22.4702 79.7492C14.8915 72.6059 10.3593 62.9652 9.70766 52.6029C9.66321 51.8985 10.1981 51.2913 10.9025 51.2476C11.6076 51.2031 12.2141 51.7388 12.2578 52.4431C13.5226 72.5607 30.3201 88.3193 50.4994 88.3193C67.4649 88.3193 82.6028 76.9497 87.3127 60.6713C87.5086 59.9932 88.2175 59.603 88.8955 59.7989C89.5736 59.9947 89.9638 60.7037 89.7679 61.3817C88.5505 65.5899 86.6671 69.5593 84.1713 73.1784C81.7116 76.7455 78.717 79.887 75.2704 82.517C71.7862 85.1755 67.9267 87.2428 63.7991 88.6628C59.5306 90.1288 55.0557 90.8739 50.5002 90.8739Z",
    fill: "url(#paint5_linear_21_622)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_622",
    x1: 21.9345,
    y1: 28.3411,
    x2: 21.9345,
    y2: 71.6596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69C0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_622",
    x1: 51.1083,
    y1: 27.9569,
    x2: 51.1083,
    y2: 72.0408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69C0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_622",
    x1: 79.0611,
    y1: 40.5205,
    x2: 79.0611,
    y2: 59.4786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69C0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21_622",
    x1: 50.4996,
    y1: 0,
    x2: 50.4996,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69C0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21_622",
    x1: 54.4999,
    y1: 9.12537,
    x2: 54.4999,
    y2: 35.8656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69C0F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21_622",
    x1: 49.7618,
    y1: 51.245,
    x2: 49.7618,
    y2: 90.8739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69C0F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg18Plus);
export default __webpack_public_path__ + "static/media/18plus.b26cc5a974760e315385012da33426ab.svg";
export { ForwardRef as ReactComponent };